import Link from 'Components/shared/Link/Link';
import styles from './PromoPrimaryButton.module.scss';
import { Url } from 'next/dist/shared/lib/router/router';

interface IPromoPrimaryButtonProps {
  href: Url;
  dataQa?: string;
  children: string;
}

const PromoPrimaryButton = ({ href, dataQa, children }: IPromoPrimaryButtonProps) => {
  return (
    <Link className={`${styles.button} ${styles.button_primary} d-fl ai-c jc-c`} href={href} data-qa={dataQa}>
      <p>{children}</p>
    </Link>
  );
};

export default PromoPrimaryButton;
